import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export const offsetLeftRightValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const offsetLeft = control.get('offsetLeft');
  const offsetRight = control.get('offsetRight');
  return offsetLeft && offsetRight && offsetLeft.value + offsetRight.value >= 1 ? { offsetLeftRightOutOfBounds: true } : null;
};
